// extracted by mini-css-extract-plugin
module.exports = {"icon_container":"SearchIcon_icon_container__30B-w","search_input":"SearchIcon_search_input__2b9Ro","parent_search":"SearchIcon_parent_search__2UCYE"};